function Promise(){
    return(
        <section className="promise-section">
        <h2 className="head">AsianElite Service Promise 💯</h2>
        <div className="promise-track">
            <div className="promise-card">
                <span>💰</span>
                <p id="promise-name">Best Price</p>
            </div>
         <div className="divide"></div>
            <div className="promise-card">
                <span>🔄</span>
                <p id="promise-name">Free Reschedule</p>
            </div>
         <div className="divide"></div>
            <div className="promise-card">
                <span>⭐</span>
                <p id="promise-name">5 Star Rated  <br />Partner</p>
            </div>
        </div>
        </section>
    )
}
export default Promise;